import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import PaypalOnePay from "../components/PaypalOnePay";
import PanelLayout from "../components/PanelLayout";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import "./styles/SuscriptionPayPanel.css";

const ONE_PAY_FEATURES = [
  "one_pay1",
  "one_pay2",
  "one_pay3",
  "one_pay4",
  "one_pay5",
];

class OnePayPanel extends React.Component {
  render() {
    const { value } = this.props;
    const price = value || 15;

    return (
      <PanelLayout>
        <div className="subscription-checkout">
          <header className="subscription-checkout-header">
            <h1>
              <Translate value="kind_pay" />
            </h1>
            <p>
              <Translate value="you_cart" />
            </p>
          </header>

          <section className="subscription-checkout-card">
            <div className="subscription-checkout-card-header">
              <h2 className="subscription-checkout-card-title">
                <Translate value="you_cart" />
              </h2>
              <span className="subscription-checkout-badge">1</span>
            </div>

            <div className="subscription-checkout-plan">
              <div className="subscription-checkout-plan-top">
                <div className="subscription-checkout-plan-info">
                  <span className="subscription-checkout-period subscription-checkout-period--onepay">
                    <Translate value="one_pay" />
                  </span>
                  <h2>
                    <Translate value="one_pay" />
                  </h2>
                  <ul className="subscription-checkout-features">
                    {ONE_PAY_FEATURES.map((featureKey) => (
                      <li key={featureKey}>
                        <Translate value={featureKey} />
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="subscription-checkout-price">
                  <span className="subscription-checkout-price-amount">
                    ${price}
                  </span>
                  <span className="subscription-checkout-price-currency">
                    USD
                  </span>
                </div>
              </div>
            </div>

            <div className="subscription-checkout-total">
              <span>
                <Translate value="checkout_total" />
              </span>
              <strong>${price} USD</strong>
            </div>
          </section>

          <section className="subscription-checkout-card">
            <div className="subscription-checkout-payment">
              <h3 className="subscription-checkout-payment-title">PayPal</h3>
              <p className="subscription-checkout-payment-note">
                <Translate value="checkout_secure_note" />
              </p>
              <div className="subscription-checkout-paypal">
                <PaypalOnePay />
              </div>
            </div>
          </section>

          <Link to="/mysuscription" className="subscription-checkout-back">
            <FaArrowLeft />
            <Translate value="suscription_mine" />
          </Link>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    value: reducer.suscriptionPlan.plan_value,
  };
}

export default connect(mapStateToProps)(OnePayPanel);
